import { render, staticRenderFns } from "./CowDeworming.vue?vue&type=template&id=7d8c7634&scoped=true&"
import script from "./CowDeworming.vue?vue&type=script&lang=js&"
export * from "./CowDeworming.vue?vue&type=script&lang=js&"
import style0 from "./CowDeworming.vue?vue&type=style&index=0&id=7d8c7634&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d8c7634",
  null
  
)

export default component.exports